/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useEffect } from 'react';
import Room from './Room';
import { useJoin } from '@/lib/useCommon';
import aigcConfig from '@/config';

function MainArea() {

  const [joining, dispatchJoin] = useJoin();

  const username = aigcConfig.BaseConfig.UserId;
  const roomId = aigcConfig.BaseConfig.RoomId;
  
  useEffect(() => {
    dispatchJoin(
      {
        username,
        roomId,
        publishAudio: true,
      },
      false
    );
  }, [])
  return <Room />;
}

export default MainArea;
